import { SafelyRenderHtml } from '@src/services/renderEditorText';

const categoryTitle = (category) => {
    if (!category.is_new) {
        return category.name;
    }

    return SafelyRenderHtml(`<span class="met_new_keyword_color" >New!</span> ${category.name}`);
};

export { categoryTitle };
